/**
 * Consulta o consentimento do banner existente (vanilla-cookieconsent, window.CookieConsentApi).
 * Sem banner carregado ou em erro, a resposta é sempre "não autorizado".
 */
export function allowed(category) {
    try {
        const api = window.CookieConsentApi;

        return !!(api && typeof api.allowedCategory === "function" && api.allowedCategory(category));
    } catch (e) {
        return false;
    }
}
